import React from 'react'

interface PreferencesSectionContainerProps {
  children: React.ReactNode
  className?: string
  withBorder?: boolean // default: true
  paddingClassName?: string // default: 'p-6'
  gapClassName?: string // default: 'gap-6'
}

/**
 * Reusable container for preference section bodies.
 * Applies vertical layout, spacing, and optional border/padding.
 */
export function PreferencesSectionContainer({
  children,
  className,
  withBorder = true,
  paddingClassName = 'p-6',
  gapClassName = 'gap-6',
}: PreferencesSectionContainerProps) {
  const classes = [
    'flex flex-col',
    gapClassName,
    withBorder ? 'border-b border-base-border' : '',
    paddingClassName,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return <div className={classes}>{children}</div>
}
